import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { Button } from "../../Button/index.js";
import { Box } from "../../Box/index.js";
import { Dialog, DialogContent } from "../../Dialog/index.js";
import { FileInput } from "../FileInput/index.js";
import { RadioInput } from "../RadioInput/index.js";
import { ImageCropper } from "../../ImageCropper/index.js";
import { Typography } from "../../Typography/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function FileInputWithCrop_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else FileInputWithCrop_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const DEFAULT_ASPECT_RATIO_VALUE = '16:9';
const DEFAULT_ASPECT_RATIO = 16 / 9;
const getBlobDimensions = (blob)=>new Promise((resolve)=>{
        const img = new Image();
        img.onload = ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
            URL.revokeObjectURL(img.src);
        };
        img.onerror = ()=>{
            resolve({
                width: 0,
                height: 0
            });
            URL.revokeObjectURL(img.src);
        };
        img.src = URL.createObjectURL(blob);
    });
const FileInputWithCrop = (_0)=>{
    let { onChange, cache, validators, aspectRatioOptions, dialogTitle = 'Кадрирование обложки', dialogDescription = 'Выделите нужную область изображения', sizeAspect } = _0, rest = _object_without_properties(_0, [
        "onChange",
        "cache",
        "validators",
        "aspectRatioOptions",
        "dialogTitle",
        "dialogDescription",
        "sizeAspect"
    ]);
    const [cropModalState, setCropModalState] = useState(false);
    const [blobDocument, setBlobDocument] = useState(void 0);
    const [croppedResult, setCroppedResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cropError, setCropError] = useState(null);
    const defaultAspectRatio = useMemo(()=>{
        var _aspectRatioOptions_;
        return (null == aspectRatioOptions ? void 0 : null == (_aspectRatioOptions_ = aspectRatioOptions[0]) ? void 0 : _aspectRatioOptions_.value) || DEFAULT_ASPECT_RATIO_VALUE;
    }, [
        aspectRatioOptions
    ]);
    const [selectedAspectRatio, setSelectedAspectRatio] = useState(defaultAspectRatio);
    const handleAspectRatioChange = (value)=>{
        setSelectedAspectRatio(String(value));
        setCropError(null);
    };
    const currentAspectRatioOption = useMemo(()=>{
        if (aspectRatioOptions && aspectRatioOptions.length > 0) return aspectRatioOptions.find((opt)=>opt.value === selectedAspectRatio);
    }, [
        aspectRatioOptions,
        selectedAspectRatio
    ]);
    const currentAspectRatio = useMemo(()=>{
        if (currentAspectRatioOption) return currentAspectRatioOption.ratio;
        if ('number' == typeof sizeAspect) return sizeAspect;
        return DEFAULT_ASPECT_RATIO;
    }, [
        currentAspectRatioOption,
        sizeAspect
    ]);
    const currentMinDimensions = useMemo(()=>{
        if (currentAspectRatioOption) return {
            minWidth: currentAspectRatioOption.minWidth,
            minHeight: currentAspectRatioOption.minHeight
        };
        return {
            minWidth: void 0,
            minHeight: void 0
        };
    }, [
        currentAspectRatioOption
    ]);
    const validateCropDimensions = useCallback((blob)=>_async_to_generator(function*() {
            const { minWidth, minHeight } = currentMinDimensions;
            if (!minWidth && !minHeight) return null;
            const { width, height } = yield getBlobDimensions(blob);
            if (minWidth && width < minWidth) return `Размер изображения не может быть меньше ${minWidth} x ${minHeight}`;
            if (minHeight && height < minHeight) return `Размер изображения не может быть меньше ${minWidth} x ${minHeight}`;
            return null;
        })(), [
        currentMinDimensions
    ]);
    const handleCropModalState = (state, reset = true)=>()=>{
            setCropModalState(state);
            setCropError(null);
            if (!state && reset) {
                setCroppedResult(null);
                setBlobDocument(void 0);
                onChange(void 0);
            }
        };
    const handleCropComplete = (croppedBlob)=>{
        setCroppedResult(croppedBlob);
        setCropError(null);
    };
    const convertToFormat = (blob_0, mimeType)=>new Promise((resolve)=>{
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = new Image();
            img.onload = ()=>{
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                null == ctx || ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);
                canvas.toBlob((resultBlob)=>{
                    resolve(resultBlob || blob_0);
                }, mimeType, 0.9);
            };
            img.src = URL.createObjectURL(blob_0);
        });
    const handleApplyCrop = ()=>_async_to_generator(function*() {
            if (!croppedResult) return;
            const validationError = yield validateCropDimensions(croppedResult);
            if (validationError) return void setCropError(validationError);
            setLoading(true);
            setCropError(null);
            let originalFileName = 'image';
            let originalFileType = 'image/jpeg';
            if (blobDocument && blobDocument.source && 'string' != typeof blobDocument.source && blobDocument.source instanceof File) {
                const fileObj = blobDocument.source;
                originalFileType = fileObj.type || 'image/jpeg';
                if (fileObj.name) originalFileName = fileObj.name;
            }
            let extension = '';
            if (originalFileType && originalFileType.includes('/')) extension = originalFileType.split('/')[1];
            let fileNameWithExt = originalFileName;
            fileNameWithExt = originalFileName.lastIndexOf('.') > 0 ? `${originalFileName.substring(0, originalFileName.lastIndexOf('.'))}.${extension}` : `${originalFileName}.${extension}`;
            const targetMimeType = originalFileType;
            const resultBlob_0 = yield convertToFormat(croppedResult, targetMimeType);
            const file = new File([
                resultBlob_0
            ], fileNameWithExt, {
                type: targetMimeType
            });
            if (!cache) return void handleCropModalState(false, false)();
            try {
                const { file_id: fileId, expired_at: expiredAt } = yield cache(file);
                onChange({
                    source: file,
                    value: JSON.stringify({
                        type: 'file_cache',
                        id: fileId,
                        expiredAt: expiredAt
                    })
                });
                setLoading(false);
                handleCropModalState(false, false)();
            } catch (error) {
                setLoading(false);
                handleCropModalState(false)();
                return;
            }
        })();
    const handleOnChange = (value_0)=>_async_to_generator(function*() {
            setBlobDocument(value_0);
            if (!value_0) return void onChange(void 0);
            if (validators && (yield validators(value_0))) return;
            if (value_0.source && 'string' != typeof value_0.source && value_0.source instanceof File) handleCropModalState(true)();
        })();
    const formattedBlob = useMemo(()=>new Blob([
            JSON.stringify({
                url: URL.createObjectURL((null == blobDocument ? void 0 : blobDocument.source) instanceof File ? blobDocument.source : new Blob())
            })
        ], {
            type: 'application/json'
        }), [
        null == blobDocument ? void 0 : blobDocument.source
    ]);
    return /*#__PURE__*/ jsxs(Box, {
        children: [
            /*#__PURE__*/ jsx(FileInput, _object_spread_props(_object_spread({}, rest), {
                onChange: handleOnChange,
                variant: "input",
                validators: validators
            })),
            /*#__PURE__*/ jsx(Dialog, {
                open: cropModalState,
                onClose: handleCropModalState(false),
                children: /*#__PURE__*/ jsx(DialogContent, {
                    onClose: handleCropModalState(false),
                    actions: /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx(Button, {
                                variant: "tertiaryLight",
                                size: "large",
                                onClick: handleCropModalState(false),
                                children: "Отменить"
                            }),
                            /*#__PURE__*/ jsx(Button, {
                                variant: "primary",
                                size: "large",
                                loading: loading,
                                disabled: loading,
                                onClick: handleApplyCrop,
                                children: "Сохранить"
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        flexDirection: "column",
                        gap: "16",
                        children: [
                            /*#__PURE__*/ jsx(Typography, {
                                variant: "h5",
                                children: dialogTitle
                            }),
                            aspectRatioOptions && aspectRatioOptions.length > 1 && /*#__PURE__*/ jsx(RadioInput, {
                                row: true,
                                withoutMargins: true,
                                items: aspectRatioOptions.map((option)=>({
                                        label: option.label,
                                        value: option.value
                                    })),
                                value: selectedAspectRatio,
                                onChange: handleAspectRatioChange
                            }),
                            /*#__PURE__*/ jsx(Typography, {
                                variant: "body1",
                                color: "text.light.secondary",
                                children: dialogDescription
                            }),
                            /*#__PURE__*/ jsx(Box, {
                                display: "flex",
                                minHeight: 300,
                                width: "100%",
                                children: /*#__PURE__*/ jsx(ImageCropper, {
                                    blob: formattedBlob,
                                    sizeAspect: currentAspectRatio,
                                    onCropComplete: handleCropComplete
                                })
                            }),
                            cropError && /*#__PURE__*/ jsx(Typography, {
                                variant: "body2",
                                color: "accent.text.error",
                                children: cropError
                            })
                        ]
                    })
                })
            })
        ]
    });
};
export { FileInputWithCrop };
